import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MissedTable from './MissedTable';
import Spinner from '../spinner';

import Text from '../../containers/Text';
import './Missed.scss';

import { ExpandMore } from '@material-ui/icons';
import {
  AccordionDetails,
  AccordionSummary,
  Accordion,
} from '@material-ui/core';

import { getMissedInvoices } from '../../api/requests/invoice';
import { getMissedReceipts } from '../../api/requests/receipt';
import { getMissedMonthly, getMissedSalaries } from '../../api/requests/monthly';

const MissedFiles = () => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [errorKey, setErrorKey] = useState(null);

  const [missedFiles, setMissedFiles] = useState({
    invoices: [],
    creditInvoices: [],
    receipts: [],
    invoiceReceipts: [],
    monthlies: [],
    salaries: [],
  });

  useEffect(() => {
    async function getActiveUsers() {
      try {
        setErrorKey(null);
        const missedInvoices = getMissedInvoices();
        const missedCreditInvoices = getMissedInvoices('invoice-credit');
        const missedReceipts = getMissedReceipts();
        const missedInvoiceReceipts = getMissedInvoices('invoice-receipt');
        const missedMonthlies = getMissedMonthly();
        const missedSalaries = getMissedSalaries();

        const result = await Promise.all([
          missedInvoices,
          missedCreditInvoices,
          missedReceipts,
          missedInvoiceReceipts,
          missedMonthlies,
          missedSalaries,
        ]).then((response) => {
          return response;
        });

        setMissedFiles({
          invoices: result[0].data.result,
          creditInvoices: result[1].data.result,
          receipts: result[2].data.result,
          invoiceReceipts: result[3].data.result,
          monthlies: result[4].data.result,
          salaries: result[5].data.result,
        });
      } catch (err) {
        setErrorKey('something-went-wrong');
      } finally {
        setIsLoading(false);
      }
    }
    getActiveUsers();
  }, []);

  const getFilesCount = (collection, filesAttribute = 'files') => {
    return collection.reduce((acc, item) => {
      return acc + item[filesAttribute].length;
    }, 0);
  };

  return (
    <div className="admin-panel-container">
      <header className="admin-panel-header">
        <div className="admin-panel-header-title">
          {t('missed-files')}
        </div>
      </header>

      {errorKey && (
        <div className="error-message">
          <Text text={t(errorKey)} />
        </div>
      )}

      {isLoading && <Spinner />}
      {!isLoading && (
        <div className="salary-content">
          <Accordion className="accordion">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Text text={t('invoices')} />
              <div className="month-number">
                <Text text={t(getFilesCount(missedFiles.invoices))} />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <MissedTable userMissedFiles={missedFiles.invoices} />
            </AccordionDetails>
          </Accordion>

          <Accordion className="accordion">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Text text={t('receipt')} />
              <div className="month-number">
                <Text text={t(getFilesCount(missedFiles.receipts))} />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <MissedTable userMissedFiles={missedFiles.receipts} />
            </AccordionDetails>
          </Accordion>

          <Accordion className="accordion">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Text text={t('invoice-c')} />
              <div className="month-number">
                <Text text={t(getFilesCount(missedFiles.creditInvoices))} />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <MissedTable userMissedFiles={missedFiles.creditInvoices} />
            </AccordionDetails>
          </Accordion>

          <Accordion className="accordion">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Text text={t('invoice/receipt')} />
              <div className="month-number">
                <Text text={t(getFilesCount(missedFiles.invoiceReceipts))} />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <MissedTable userMissedFiles={missedFiles.invoiceReceipts} />
            </AccordionDetails>
          </Accordion>

          <Accordion className="accordion">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Text text={t('monthly-files')} />
              <div className="month-number">
                <Text
                  text={t(getFilesCount(missedFiles.monthlies))}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <MissedTable userMissedFiles={missedFiles.monthlies} />
            </AccordionDetails>
          </Accordion>

          <Accordion className="accordion">
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Text text={t('payslip')} />
              <div className="month-number">
                <Text
                  text={t(getFilesCount(missedFiles.salaries))}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <MissedTable userMissedFiles={missedFiles.salaries} />
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default MissedFiles;
